/** Options of a SearchableDropdown, and its default client-side filter. */

export interface DropdownOption {
  value: string;
  label: string;
  /** Muted text on the right of the row (e.g. a status). */
  hint?: string | null;
}

/** Options whose label or value contains `query` (case-insensitive). */
export function filterOptions(options: DropdownOption[], query: string): DropdownOption[] {
  const q = query.trim().toLowerCase();
  if (!q) return options;
  return options.filter((o) => o.label.toLowerCase().includes(q) || o.value.toLowerCase().includes(q));
}
